/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { firstValueFrom, Observable } from 'rxjs';
import { NgSelectOption } from '~shared/interface/ngselect.interfaces';

export function convertStringToType<T>(s: string | null): T | null {
	if (s == null) return null;

	if (s.trim() == '') return null;

	try {
		return JSON.parse(s) as T;
	} catch {
		return null;
	}
}

// eslint-disable-next-line @typescript-eslint/naming-convention
// const OMIT_PROPERTY = ['links', 'label', 'value'];

export interface CompareResult<T = any> {
	value: T;
	equal: boolean;
}

export function isObject<T>(object: T): boolean {
	return object !== null && typeof object === 'object';
}

export function isObjEmpty<T>(object: T): boolean {
	if (object === null || object === undefined) return true;

	return Object.keys(object).length === 0;
}

type D = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	[key: string]: any;
};

export function equals<T>(o1: T, o2: T): boolean {
	if (o1 === o2) return true;
	if (o1 === null || o2 === null) return false;
	if (Number.isNaN(o1) && Number.isNaN(o2)) return true; // NaN === NaN

	const t1 = typeof o1;
	const t2 = typeof o2;

	if (t1 !== t2 || t1 !== 'object') return false;

	cleanupObject(o1);
	cleanupObject(o2);

	if (Array.isArray(o1)) {
		return Array.isArray(o2) && compareArrays(o1, o2);
	}
	return !Array.isArray(o2) && compareObjects(o1, o2);
}

function cleanupObject<T>(obj: T): void {
	if ((obj as D)['label']) delete (obj as D)['label'];
	if ((obj as D)['links']) delete (obj as D)['links'];
}

function compareArrays<T>(arr1: T[], arr2: T[]): boolean {
	if (arr1.length !== arr2.length) return false;
	return arr1.every((item, index) => equals(item, arr2[index]));
}

function compareObjects<T>(o1: T, o2: T): boolean {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	const keySet = Object.create(null);
	for (const key in o1) {
		if (!equals(o1[key] ?? null, o2?.[key] ?? null)) return false;
		keySet[key] = true;
	}
	return Object.keys(o2 ?? {}).every((key) => key in keySet || typeof (o2 as any)[key] === 'undefined');
}

export function compareObject<T extends object>(objectCurrent: T, objectTemp: T): CompareResult<T> {
	const isEqual = compare(objectCurrent, objectTemp);
	return {
		value: objectCurrent,
		equal: isEqual,
	};
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function generateUUID(): string {
	let d = new Date().getTime();
	const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		const r = (d + Math.random() * 16) % 16 | 0; //NOSONAR
		d = Math.floor(d / 16);
		return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
	});

	return uuid;
}

export function completedCharacter(value: string, count: number, character = '0'): string {
	if (value == null) return '';

	const length = value.trim().length;
	let completed = '';

	for (let i = length; i < count; i++) {
		completed += character;
	}

	return completed + value;
}

function convertToType<T>(formControl: AbstractControl | null): Required<T> | null {
	if (formControl == null) return null;

	const formValue = formControl.value as unknown;

	if (formValue == null) return null;

	if (typeof formValue === 'object') {
		const object = formValue as NgSelectOption<T> & { links: [] };

		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const { label, value, links, ...res } = object;
		return { ...res } as unknown as Required<T>;
	}

	return formValue as Required<T>;
}

function clearObject<T>(object: T): T | null {
	if (object && typeof object === 'object') {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
		const e = object as NgSelectOption<any> & { links: [] };
		// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-unsafe-assignment
		const { label, value, links, ...res } = e;

		if (isObjEmpty(res)) return null;
		return res as T;
	}
	return object;
}

export function convertFormGroupToModel<T>(formGroup: UntypedFormGroup, strict = false): Required<T> {
	if (!strict) return { ...formGroup.getRawValue() } as Required<T>;

	const object = formGroup.getRawValue() as Required<T>;
	// eslint-disable-next-line prefer-const
	let obj: { [key: string]: any } = {};

	for (const key in object) {
		if (!Object.hasOwn(object, key)) continue;
		const element = object[key];
		obj[key] = element && typeof element === 'object' ? processObjectElement<T>(element) : element;
	}
	return obj as Required<T>;
}

function processObjectElement<T>(element: any): unknown {
	if (Array.isArray(element)) {
		return (element as unknown as []).map(clearObject);
	}
	const e = element as NgSelectOption<T> & { links: [] };
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { label, value, links, ...res } = e;
	return isObjEmpty(res) ? null : res;
}

export function convertFormToType<T>(form: UntypedFormControl | AbstractControl | null): Required<T> | null;
export function convertFormToType<T, K>(form: UntypedFormGroup, property: keyof K): Required<T> | null;
export function convertFormToType<T, K>(form: UntypedFormControl | AbstractControl | UntypedFormGroup | null, property?: keyof K): Required<T> | null {
	if (form == null) return null;

	if (form instanceof UntypedFormControl) return convertToType<T>(form);

	if (form instanceof UntypedFormGroup) {
		return convertToType<T>(form.get(property as string));
	}

	return null;
}

export function convertObserverToPromise<T>(...observer: Observable<T>[]): Promise<T>[] {
	return observer.map((o) => firstValueFrom(o));
}

export function convertTypeRequired<T>(value: T): Required<T> {
	return value as Required<T>;
}

export function deletePropertyNullOrUndefined<T>(obj: T): T {
	const cloneObj = structuredClone(obj);

	for (const key in cloneObj) {
		if (Object.hasOwn(cloneObj as object, key)) {
			const element = cloneObj[key];
			if (element == null) delete cloneObj[key];
			else if (typeof cloneObj[key] === 'object') {
				deletePropertyNullOrUndefined(cloneObj[key]);
				if (Array.isArray(cloneObj[key]) && (cloneObj[key] as any).length === 0) {
					delete cloneObj[key];
				}
				cleanupObject(element);
			}
		}
	}

	return cloneObj;
}

export function clearProperty<T extends object>(obj: T): T {
	const object = structuredClone(obj);

	for (const key in object) {
		if (Object.hasOwn(object, key)) {
			const element = object[key];

			if (Array.isArray(element) && element.length == 0) {
				delete object[key];
			}
			if (Array.isArray(element) && element.length > 0) {
				for (const obj of element) {
					clearProperty(obj);
				}
			}

			clearPropertyObject(object, key);
		}
	}

	return object;
}

function shouldDeleteProperty<T>(object: T, key: keyof T, k: keyof T[keyof T]): boolean {
	return !k.toString().startsWith('id') || (k.toString().startsWith('id') && typeof object[key]?.[k] !== 'object' && !key.toString().includes(k.toString().substring(2)));
}

function clearPropertyObject<T>(object: T, key: keyof T): void {
	if (!Array.isArray(object[key]) && object[key] != null && typeof object[key] == 'object') {
		for (const k in object[key]) {
			if (shouldDeleteProperty(object, key, k)) {
				delete object[key][k];
			} else if (k.startsWith('id') && typeof object[key][k] == 'object') {
				for (const kNested in object[key]) {
					clearPropertyObject(object[key], kNested);
				}
			}
		}
	}
}

export function compare<T>(objectApi: T, currentObject: T): boolean {
	const isNullOrUndefined = (...val: any[]) => val.every((data) => data == null || data === undefined);
	if (objectApi === currentObject) return true;
	if (numberIsNaN(objectApi, currentObject)) return true; // NaN === NaN
	if (isNullOrUndefined(objectApi, currentObject)) return false;

	for (const k in objectApi) {
		const elementT = objectApi[k];
		const elementC = currentObject[k];
		// Handle null/undefined cases
		if (checkNullUndefinedMismatch(elementT, elementC, isNullOrUndefined)) return false;
		// Handle arrays
		if (Array.isArray(elementT) && Array.isArray(elementC)) {
			if (!compareArrayElements(elementT, elementC)) return false;
			continue;
		}
		// Handle non-array objects and primitives
		if (!compareNonArrayObject(elementT, elementC)) return false;
	}
	return true;
}

function checkNullUndefinedMismatch<T>(elementT: T, elementC: T, isNullOrUndefined: (val: any) => boolean): boolean {
	return (isNullOrUndefined(elementT) && !isNullOrUndefined(elementC)) || (!isNullOrUndefined(elementT) && isNullOrUndefined(elementC));
}

function compareArrayElements<T>(elementT: T[], elementC: T[]): boolean {
	if (elementT.length !== elementC.length) return false;
	return elementT.every((item, index) => compare(item, elementC[index]));
}

function compareObjectProperties<T>(objT: T, objC: T): boolean {
	for (const key in objT) {
		const valueT = objT[key];
		const valueC = objC[key];
		if (typeof valueT !== 'object' && valueT !== valueC) return false;
		if (typeof valueT === 'object' && !compare(objT, objC)) return false;
	}
	return true;
}

function compareNonArrayObject<T>(elementT: T, elementC: T): boolean {
	if (!Array.isArray(elementT) && typeof elementT != 'object' && elementT != elementC) {
		if (elementC != null || elementC == null) {
			return false;
		}
	}
	if (Array.isArray(elementT) && typeof elementT !== 'object') return true;
	return compareObjectProperties(elementT, elementC);
}

function numberIsNaN<T>(...elements: T[]): boolean {
	return elements.every((element) => Number.isNaN(element));
}
